import { debounce } from 'lodash-es';

export default {
  methods: {
    updateHistory: debounce(function () {
      window.om.bus.$emit('historySave');
    }, 500),
  },
};
